import { useEffect, useState } from 'react';

const CONSULTA = '(prefers-reduced-motion: reduce)';

/**
 * ¿El visitante ha pedido que no le muevan la pantalla?
 *
 * `landingV3.css` ya para las animaciones que son puro CSS. Este hook es para
 * las que lleva JavaScript —el ranking del hero, el ciclo del comparador del
 * Mapa SEO—, donde no basta con no animar: hay que dejar el componente en el
 * estado que la sección quiere contar (el primer puesto, la vista de
 * diferencia) en vez de congelarlo en el inicial, que no dice nada.
 *
 * Se suscribe al cambio, no solo lo lee al montar: la preferencia se puede
 * activar con la página abierta, y quien la activa suele estar mareándose justo
 * en ese momento.
 *
 * Tolera que no haya `matchMedia`: en jsdom no existe salvo que el test lo
 * ponga, y una landing que revienta en el render por una media query sería un
 * intercambio pésimo.
 */
export default function useReducedMotion() {
  const [reducido, setReducido] = useState(() => leer());

  useEffect(() => {
    const mq = typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia(CONSULTA)
      : null;
    if (!mq) return undefined;

    const alCambiar = (e) => setReducido(e.matches);

    // `addEventListener` es lo moderno; `addListener` es el respaldo para
    // Safari < 14, que todavía se ve en iPhones que no actualizan.
    if (mq.addEventListener) mq.addEventListener('change', alCambiar);
    else if (mq.addListener) mq.addListener(alCambiar);

    setReducido(mq.matches);

    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', alCambiar);
      else if (mq.removeListener) mq.removeListener(alCambiar);
    };
  }, []);

  return reducido;
}

function leer() {
  try {
    return !!window.matchMedia?.(CONSULTA)?.matches;
  } catch {
    return false;
  }
}
